
export default {
  data() {
    return {
      title:
        "Resources | Get a Bikeflights.com Logo | Vector Logos | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "branding",
          name: "branding",
          content: "Download Bikeflights.com logos, badges and branding guide",
        },
      ],
    };
  },
};
